import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { LineClamp } from '../../global/commonStyle';

const Main = styled.div<{ isActive: boolean }>`
  /* max-width: 184px; */
  width: 100%;
  border-radius: var(--border-radius-12);
  border: 0.5px solid var(--border-primary);
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-card);
  .more-icon {
    display: none;
  }
  &:hover {
    cursor: pointer;
    box-shadow: var(--shadow-card-hover);
    .overlay {
      display: block;
    }
    .more-icon {
      display: flex;
      background-color: var(--neutral-secondary);
    }
  }
  ${(props) =>
    props.isActive &&
    css`
      box-shadow: var(--shadow-card-hover);
      .overlay {
        display: block;
      }
      .more-icon {
        display: flex;
      }
    `}
  ${mobile_xl(css`
    .more-icon {
      display: flex;
    }
  `)}
`;
const Top = styled.div`
  height: 106px;
  position: relative;
  .img {
    width: 100%;
    height: 106px;
    /* max-width: 184px; */
    object-fit: cover;
    border-radius: var(--border-radius-12) var(--border-radius-12) var(--border-radius-0) var(--border-radius-0);
  }
  video {
    border-radius: var(--border-radius-12) var(--border-radius-12) var(--border-radius-0) var(--border-radius-0);
    height: 100%;
    width: 100%;
    object-fit: cover;
    /* max-width: 184px; */
  }
`;

const Bottom = styled.div`
  border-top: 0.5px solid var(--border-primary);
  padding: var(--space-11) var(--space-12) var(--space-12);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
`;
const Title = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  ${LineClamp(1)}
  word-break: break-all;
`;

const Time = styled.div`
  ${Typography.body_sm}
  color: var(--text-secondary);
`;
const Overlay = styled.div`
  background-color: var(--background-overlay-2);
  top: 0;
  left: 0;
  width: 100%;
  height: 106px;
  position: absolute;
  border-radius: var(--border-radius-12) var(--border-radius-12) var(--border-radius-0) var(--border-radius-0);
  display: none;
  cursor: pointer;
`;
const MoreIcon = styled.div`
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  .fillColor {
    fill: var(--text-secondary);
    stroke: var(--text-secondary);
    &:hover {
      background-color: var(--neutral-secondary);
      border-radius: var(--border-radius-4);
    }
  }
  .active {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-6);
  }
`;

const Div = styled.div``;

export { Main, Top, Bottom, Title, Time, Overlay, MoreIcon, Div };
